import styled from '@emotion/styled';

interface Props {
    isThin?: boolean;
}

function Divider({ isThin }:Props) {
    return (isThin ? <Thin aria-label='divider' /> : <Normal aria-label='divider' />);
}

const Normal = styled.div`
    background-color: var(--color-background-base);
    border-top: 1px solid var(--color-border-default);
    height: var(--spacing-2);
    min-height: var(--spacing-2);
    width: 100%;
`;

const Thin = styled.div`
    background-color: var(--color-background-raised);
    height: 1px;
    width: 100%;
`;

export default Divider;
